import { Injectable, inject } from '@angular/core';
import { AuthActions } from '@interacta-shared/data-access-auth';
import { LocalStorageService } from '@interacta-shared/data-access-common';
import { PostActionsApi } from '@modules/communities/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromRouter from '@ngrx/router-store';
import { map } from 'rxjs/operators';
import { UIActions } from '.';

const ONLY_UNREAD_STORAGE_KEY = 'onlyUnreadNotification';

@Injectable()
export class UiEffects {
    private actions = inject(Actions);
    private localStorageService = inject(LocalStorageService);

    closeFullscreen$ = createEffect(() =>
        this.actions.pipe(
            ofType(
                PostActionsApi.addCommentSuccess,
                PostActionsApi.saveEditCommentSuccess,
                fromRouter.routerNavigatedAction,
            ),
            map(() => UIActions.closeCommentFullScreen()),
        ),
    );

    initializeOnlyUnreadNotification$ = createEffect(() =>
        this.actions.pipe(
            ofType(AuthActions.login),
            map(() => {
                const onlyUnread =
                    this.localStorageService.getEntry<boolean>(
                        ONLY_UNREAD_STORAGE_KEY,
                    ) ?? false;
                return UIActions.toggleOnlyUnreadNotification({
                    onlyUnread,
                });
            }),
        ),
    );
}
